import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=323fb7d3&scoped=true"
import script from "./OffersTable.vue?vue&type=script&lang=js"
export * from "./OffersTable.vue?vue&type=script&lang=js"
import style0 from "./OffersTable.vue?vue&type=style&index=0&id=323fb7d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323fb7d3",
  null
  
)

export default component.exports